import React, { useState } from 'react'
import Field from './Field'
import styles from './Login.module.css'
// import { GoogleLogin } from 'react-google-login';
import {useDispatch} from 'react-redux'
import {useHistory} from 'react-router-dom'
import { signup, signin } from '../../actions/auth'

const initialState ={ firstName: '', lastName: '', role: 'user', email: '', password: '', confirmPassword: '', profilePicture: ''}

const Login = () => {


    const [formData, setFormData] = useState(initialState)
    const [isSignup, setIsSignup] = useState(false)
    const dispatch = useDispatch()
    const history = useHistory()
    
    const handleChange =(e)=> {
        setFormData( {...formData, [e.target.name] : e.target.value} )
    }

    const handleSubmit =(e) => {
        e.preventDefault()
        if(isSignup) {
            dispatch(signup(formData, history))
        } else {
            dispatch(signin(formData, history))
        }
        
    }


    const switchForm =() => {
        setIsSignup((prevState) => !prevState)
    }

   

    // const googleSuccess = async (res) => {
    //     console.log(res)
    //     const result = res?.profileObj
    //     const token = res?.tokenId

    //     try {
    //         dispatch({ type: "AUTH", data: {result, token}})

    //         history.push('/')
            
    //     } catch (error) {
    //         console.log(error)
    //     }
      
    //     console.log(formData)
    // }
    // const googleFailure =(error) => {
    //     console.log(error)
    //     console.log("Google Sign In was unseccassful. Try again later")
    // }

    const showPassword = false
    return (
        <div className={styles.pageContainer}>
            <div className={styles.formContainer}>
                <h3 className={styles.title}>{isSignup ? "Sign Up" : "Sign In"} </h3>
                <form onSubmit={handleSubmit}>
                    {
                        isSignup && (
                            <>
                                <Field name="firstName" placeholder="First Name" handleChange={handleChange} type="text" />
                                <Field name="lastName" placeholder="Last Name" handleChange={handleChange} type="text" />
                                {/* <Field name="role" placeholder="Role" handleChange={handleChange} type="text" /> */}
                            </>
                        )
                    }
                    
                    <Field name="email" placeholder="Email" handleChange={handleChange} type="email" />
                    <Field name="password" placeholder="Password" handleChange={handleChange} type={showPassword? "text" : "password"} />
                    {isSignup && (
                        <Field name="confirmPassword" placeholder="Confrim password" handleChange={handleChange} type="password" />
                    )
                    }
                    <div className={styles.buttons}>
                        <div><button className={styles.submitBtn} type="submit">{isSignup? "Sign up" : "Sign in"}</button></div>
                        {/* <div>
                            <GoogleLogin 
                                clientId= "1078487093719-vd8ccut3e0nro0tk0dg3ng8gi3trdpj8.apps.googleusercontent.com"
                                render={(renderProps) => (
                                    <button 
                                    className={styles.googleBtn} 
                                    onClick={renderProps.onClick}
                                    disabled={renderProps.disabled}>
                                    <i className="fab fa-google"></i> Google Sign In</button>
                                )}

                                onSuccess={googleSuccess}
                                onFailure={googleFailure}
                                cookiePolicy="single_host_origin"
                            />
                        </div> */}
                    </div>
                </form>

                    <div>
                    <button className={styles.switchBtn} onClick={switchForm}>{isSignup? "Already have an account? Sign In" : "Don't have an account? Sign Up"}</button>
                    </div>

            </div>
            {/* <p>Can't login? reload the page</p> */}
        </div>
    )
}

export default Login
